module.exports = __webpack_public_path__ + "img/case_special_small.7894d757.png";